import script from "./ViewPaymentVouchersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPaymentVouchersPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewPaymentVouchersPage.vue?vue&type=style&index=0&id=484ed988&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-484ed988"]])

export default __exports__